<template>
    <div class="bg-white">
        <div class="max-w-7xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
            <h2 class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                <span class="block">{{ $t('marketing.section8.cta_line1') }}</span>
                <span class="block">{{ $t('marketing.section8.cta_line2') }}</span>
            </h2>

            <div class="mt-8 flex justify-center">
                <div class="inline-flex rounded-md shadow">
                    <a
                        target="_blank"
                        :href="
                            `mailto:info@tichit.com?body=` +
                            $t('marketing.section8.mailto_body') +
                            `&subject=` +
                            $t('marketing.section8.mailto_subject')
                        "
                        class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
                    >
                        <svg
                            class="w-6 h-6 mr-1"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                        {{ $t('marketing.section8.cta_contact_us') }}
                    </a>
                </div>
                <div class="ml-3 inline-flex">
                    <a
                        href="https://twitter.com/tichit_es"
                        class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
                    >
                        {{ $t('marketing.section8.cta_more_info') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LandingContactSection',
};
</script>
